import { Modal, Stack } from "react-bootstrap";
import { Row } from "react-bootstrap";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const PaymentModal = ({ onHide, show, sessionDetail, onPaymentCompleteHandler }) => {
    const [clientSecret, setClientSecret] = useState(null);

    useEffect(() => {
        if (sessionDetail) {
            setClientSecret(sessionDetail?.client_secret || null);
        }
    }, [sessionDetail]);

    // Wipe clientSecret when modal closes → unmounts provider cleanly
    useEffect(() => {
        if (!show) {
            setClientSecret(null);
        }
    }, [show]);

    const stableOnComplete = useCallback(() => {
        onPaymentCompleteHandler?.();
    }, []);

    const options = useMemo(() => ({
        clientSecret,
        onComplete: stableOnComplete,
    }), [clientSecret]);

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    <h3 className="fw-bold text-center mb-1">Pay Now</h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Stack direction="vertical" gap={3}>
                    <Row>
                        {clientSecret && (
                            <EmbeddedCheckoutProvider
                                key={clientSecret}
                                stripe={stripePromise}
                                options={options}
                            >
                                <EmbeddedCheckout />
                            </EmbeddedCheckoutProvider>
                        )}
                    </Row>
                </Stack>
            </Modal.Body>
        </Modal>
    );
};

export default React.memo(PaymentModal);
